Vue.component('Courses', () => import('./Courses'))
Vue.component('CourseMerge', () => import('./CourseMerge'))
Vue.component('CourseView', () => import('./CourseView'))
Vue.component('CourseViewStatistics', () => import('./CourseViewStatistics'))
Vue.component('CourseSelect', () => import('./CourseSelect'))